/* global fetch $  */
import $ from "jquery";
import { messageEllipse, messagefromSystem, initBotInstance, messagefromBot } from "./dialog_messages.js";
import { getConfig } from "../general_functions.js";
import dayjs from "dayjs";
import { set_accordian } from "../accordian.js";
import kariavatar from "../kariavatar";
import language from "../translation";

export const chatFocus = (bg = true, buttons = true) => {
    if (bg === true) {
        // console.log("change?",$(".dialog__avatarcontainer").length);
        $(".chatbot-search").addClass("transform-bg");
        $(".dialog__avatarcontainer").addClass("dialogongoing");
    }
    else {
        $(".chatbot-search").removeClass("transform-bg");
        // $(".dialog__avatarcontainer").removeClass("dialogongoing");
    }
    if (buttons === true) {
        $(".chatbot-search").addClass("show-actions");
    }
    else {
        $(".chatbot-search").removeClass("show-actions");
    }
};

export const setScrollBottom = () => {


    if ($("#chatbot__container").hasClass("chatbot__mobile-show")) {
        // console.log("mobile ok");
        var element = document.getElementById("chatbot__messagearea");
        element.scrollTop = element.scrollHeight;

        $("body").addClass("noscroll");

    }
    else if ($("#chatbot__container").hasClass("chatbot__mobile")) {

    }
    else {
        let realScrollTop = window.scrollY;
        let requiredHeight = document.querySelector(".chatbot-search--container").offsetHeight + 300 - window.innerHeight;

        if (realScrollTop <= requiredHeight) {
            window.scrollTo(0, requiredHeight);
        }
    }

};

export const conversationPrint = () => {
    const currentConversation = sessionStorage.getItem("conversationHtml");
    if (currentConversation) {
        $("#kari__dialog__window").html(`<div class='dialog__history'>${currentConversation}</div>`);
    }

    // console.log("setting accordian (conversationPrint)")
    set_accordian();

};

export const setBackground = () => {
    $("[data-background]").each(function() {

        let bg_image = $(this).data("background") || false;

        if (bg_image) {
            $(this).css({
                "background-image": "url('" + bg_image + "')", // https://dev.prokomcdn.no/richard/aim-portal/standard/src/assets/kongsberg.jpg
                "background-size": "cover",
                "background-position": "center var(--dialog__cb__image_vertical-position, center)",
                "background-repeat": "no-repeat"
            });
        }

    });
};

export const deleteDialog = () => {

    window.scrollTo(0, 0);


    $("#kari__dialog__window").html("");

    messageEllipse();
    messagefromSystem(language("DELETE_ALL_TRACKS"));

    setTimeout(function() {

        $(".removewhendone").remove();

        messagefromSystem(language("CONVERSATION_DELETED"));
        messagefromSystem("", "seperator");

        sessionStorage.removeItem("conversation");
        sessionStorage.removeItem("chat_sessionid");
        sessionStorage.removeItem("conversationHtml");


        initBotInstance();

    }, 1000);


    let body = { command: "DELETE" }

    if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
        body.conversation_id = sessionStorage.getItem("chat_sessionid")
    }

    fetch("//007prokom.boost.ai/api/chat/v2", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
    }).then(res => {


    });


};

export const restartDialog = () => {

    window.scrollTo(0, 0);

    messageEllipse();

    setTimeout(function() {

        $(".removewhendone").remove();

        messagefromSystem("", "seperator");

        sessionStorage.removeItem("conversation");
        sessionStorage.removeItem("chat_sessionid");
        sessionStorage.removeItem("conversationHtml");


        initBotInstance();

    }, 500);


};

export const hideChat = (state = true) => {

    const config = getConfig();
    let convHtml = sessionStorage.getItem("conversationHtml") || "";

    const startKariChat = () => {

        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || vw < 576) {
            //messagefromSystem(language("CHAT_INTROMSG_3"), "html", true, "dialog__start first");
            $(".chatbot__container").addClass("chatbot__mobile");
        }
        else {
            // false for not mobile device
            // messagefromSystem(language("CHAT_INTROMSG_1"), "html", true, "dialog__start first");
            // messagefromSystem(language("CHAT_INTROMSG_2"), "html", true, "dialog__start");
            // messagefromSystem(language("CHAT_INTROMSG_3"), "html", true, "dialog__start");

            let msgnr = 0;
            const fromKari = JSON.parse(sessionStorage.getItem("chat_initialresponse"));
            $.each(fromKari, function(a, b) {
                let msgNrClass = (msgnr === 0) ? "dialog__start first" : "dialog__start";
                messagefromSystem(b.payload.html, b.payload.type, true, msgNrClass);
                // setScrollBottom();
                msgnr++;
            });
        }

    };

    if (state === true) {


        $("#kari__dialog__window").empty();

        if (config.template != "frontpage") {
            $(".chatbot-search").addClass("condensed continue");
            $(".dialog__avatarcontainer").addClass("dialog__avatarcontainer-condensed dialog__avatarcontainer-continue");
            let kari = kariavatar();
            $(".dialog__avatarcontainer")[0].innerHTML = kari;
            chatFocus(true, false);
            if (convHtml.length > 0) {
                $(".dialog__input").attr("placeholder", language("CONTINIUE_CONVERSATION"));
            }
            else {
                $(".dialog__input").attr("placeholder", language("START_OR_SEARCH"));
            }
            window.scrollTo(0, 0);
        }
        else {
            // 
            // console.log("taglength", $(convHtml).find(".dialog__fromkari").length);

            if ($(convHtml).find(".dialog__fromkari").length > 3) {

                $(".chatbot-search").addClass("continue");
                $(".dialog__avatarcontainer").addClass("dialog__avatarcontainer-continue");
                chatFocus(false, false);

                $(".dialog__input").attr("placeholder", language("CONTINIUE_CONVERSATION"));
                window.scrollTo(0, 0);
            }
            else if ($(convHtml).find(".dialog__fromkari").length == 3) {
                chatFocus(false, false);
                startKariChat();
            }
            else {
                //$(".chatbot-search").addClass("continue");
                chatFocus(false, false);
                if ($(".dialog__fromkari.dialog__start").length < 1) {
                    startKariChat();
                }
            }

        }



    }
    else {

        chatFocus();
        $(".chatbot-search").removeClass("condensed continue");
        $(".dialog__avatarcontainer").removeClass("dialog__avatarcontainer-condensed dialog__avatarcontainer-continue");
        $(".dialog__input").attr("placeholder", "");
        conversationPrint();
        setScrollBottom();

    }


};

export const createAddDislike = (obj) => {


    $("#kari__dialog__window").append(
        messagefromBot({ type: "vote", html: `
        <div class='dialog__feedback__buttons text-right'>
            <button data-id="${obj.response.id}" data-value="positive" class="btn btn-light dialog__feedback__button dialog__feedback__button--positive"><span class="budlight-like"></span></button>
            <button data-id="${obj.response.id}" data-value="negative" class="btn btn-light dialog__feedback__button dialog__feedback__button--negative"><span class="budlight-dislike"></span></button>
        </div>` })
    );

    setScrollBottom();
};

export const deleteOnInactivity = () => {

    if (parseInt(sessionStorage.getItem("lastmessage")) < dayjs().subtract(1, 'minute').valueOf()) {

        $("#kari__dialog__window").html("");


        messageEllipse();
        messagefromSystem(language("INACTIVE_DELETION"));

        $(".removewhendone").remove();

        messagefromSystem("", "seperator");

        sessionStorage.removeItem("conversation");
        sessionStorage.removeItem("chat_sessionid");
        sessionStorage.removeItem("conversationHtml");

        initBotInstance();
    }

};

export const getMetaValue = (metaobj, key) => {
    if (typeof metaobj !== "object")
        return false;

    var matches = [];

    $.each(metaobj, function(a, b) {
        if (b.name === key) {
            matches.push(b.value);
        }
    });

    if (matches.length === 1)
        return matches[0]
    else
        return matches;

}
